import "../../../css/DesignSystem/Buttons/SecondaryButton.css";

const ButtonSecondarySmall = ({
  onClick,
  type = "button",
  disabled = false,
  label = "Previous Step",
  className = "",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`ds-secondary-btn ${className}`}
    >
      <div className="Button-Text-Medium">{label}</div>
    </button>
  );
};

export default ButtonSecondarySmall;
